import Icon from '@components/v2/ui/Icon/Icon';
import { BookOpen } from 'lucide-react';
import { CatalogSearchResultItem } from '../../../../globalSearch.types';
import HighlightedText from '../../../HighlightedText';
import ResultRowBase from '../../ResultRowBase';
import { ResultRowRendererProps } from '../../resultRow.types';

function CatalogRow({
  item,
  query,
  isActive,
  isDisabled,
  domId,
  onSelect,
}: ResultRowRendererProps<CatalogSearchResultItem>) {
  return (
    <ResultRowBase
      testId={`global-search-item-${item.entityType}-${item.id}`}
      isActive={isActive}
      isDisabled={isDisabled}
      domId={domId}
      onClick={onSelect}
      leading={<Icon icon={BookOpen} size="md" />}
      title={<HighlightedText text={item.title} query={query} />}
    />
  );
}

export default CatalogRow;
